module.exports = __webpack_public_path__ + "media/images/insurance-icon-27439476260fa1a58a6b757455d80137.png";